import { useRouter } from "next/navigation";
import { useFormContext } from "react-hook-form";
import { useDebounce } from "react-use";

import { normalizeTnsName } from "@coinbot/forge-api/external";

import { api } from "~/services/api";
import { FormValues } from "./Navbar";

export const useNavbarSearch = () => {
  const form = useFormContext<FormValues>();
  const router = useRouter();

  const [search, isPopoverOpen] = form.watch(["search", "meta.isPopoverOpen"]);

  const {
    refetch,
    isFetching,
    isRefetching,
    isFetched,
    data: { listings: tnsItems } = { listings: [] },
  } = api.tns.all.useQuery(
    {
      limit: 5,
      filters: {
        contains: normalizeTnsName(search?.replaceAll(".thor", "")),
        status: ["active"],
        modelTypes: ["listings", "thornames"],
      },
    },
    { enabled: false, refetchOnMount: isPopoverOpen },
  );

  useDebounce(() => refetch(), 700, [search, isPopoverOpen]);

  const setIsPopoverOpen = (isOpen: boolean) => form.setValue("meta.isPopoverOpen", isOpen);

  const onSearch = ({ search }: FormValues) => {
    const tnsName = encodeURIComponent(normalizeTnsName(search));

    try {
      if (tnsItems?.length === 1) {
        if (tnsItems?.[0]?.type === "unregistered_thorname") {
          router.push(`/register?tns=${tnsName}`);
          return;
        }

        if (tnsItems?.[0]?.type === "thorname") {
          router.push(`/tns/${tnsName}`);
          return;
        }
      }

      router.push(`/market?contains=${tnsName}`);
    } finally {
      setIsPopoverOpen(false);

      (document?.activeElement as HTMLInputElement)?.blur();
    }
  };

  const onSubmit = form.handleSubmit(onSearch);

  const isEmpty = !!tnsItems && tnsItems?.length === 0;

  return {
    isPopoverOpen,
    setIsPopoverOpen,
    onSubmit,
    tnsItems,
    isFetched,
    isFetching,
    isRefetching,
    isEmpty,
  };
};
